<template>
  <section id="footer" style="background-color:#0C3874">
    <div class="container" style="text-align:center;padding-bottom:2vw">
      <div class="row text-center footerWrap" style="margin-bottom:10vw">
        <div style="display:flex;align-items: center;">
          <img v-lazy="'../../static/img/logo2.png'" style="width:15vw;height:3vw;margin-right:3vw" alt="">
          <div style="width:100%">
            <div style="display:flex;">
            <a @click="clickMethod('header')" style="margin-right:1vw;display:block">首页</a>
            <a @click="clickMethod('cooperation')" style="margin-right:1vw;display:block">代理合作</a>
            <a @click="clickMethod('advertisement')" style="margin-right:1vw;display:block">广告合作</a>
            <a @click="clickMethod('driver')" style="margin-right:1vw;display:block">司机招募</a>
            <a @click="clickMethod('huozhu')" style="margin-right:1vw;display:block">货主邀请</a>
            <a @click="clickMethod('companyProfile')" style="margin-right:1vw;display:block">企业介绍</a>
            <a @click="clickMethod('productsServices')" style="margin-right:1vw;display:block">产品&服务</a>
            <a @click="clickMethod('contactUs')" style="margin-right:1vw;display:block">联系我们</a>
          </div>
          <div style="margin-top:10px;height:1px;width:100%;background-color:#F1F1F1;opacity: 0.2;"/>
          </div>
        </div>
      </div>
      <p style="cursor:pointer">Copyright © 2019-现在 Hawksu.com 版权所有 ｜ <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024721号-1</a></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
    clickMethod (option) {
      this.$emit('clickMethod', option)
    }
  }
}
</script>

<style scoped>
.footerWrap{
  padding: 20px 11px;
}
.footerLogo{
  width: 100px;
  float: right;
}
@media (max-width: 640px){
  .footerLogo{
    width: 100%;
  }
}
a {
  color: white;
}
a:hover{
    color: #0091EB;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue